export const getOption = (business, optionId) => {
    const option = business.options.find((o) => o.id === optionId);

    return option;
};

export default getOption;
